export default {
    name: 'Nume',
    last_name: 'Prenume',
    phone: 'Telefon',
    email: 'Email',
    price: 'Pret',
    total_price: 'Pret total',
    nights: 'Noptii',
    choose_period: 'Alege perioada',
    check_in: 'Check In',
    check_out: 'Check Out',
    number_of_nights: 'Numar noptii',
    accept_terms: 'Accepta termeni si conditii',
    reserve_now: 'Rezerva acum',
    buy_now: 'Cumpara acum',
}
